// #region Imports
import { defineComponent, nextTick } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-cart-page',
    // #endregion
    // #region Properties
    data: () => ({
        cart: {},
        schema: {},
        data: {},
        user: {},
        oci: null,
        status: {
            mode: "",
            messages: [],
            errorMessage: "",
            hasConditionError: false,
            isLoading: false,
            isLoaded: false,
            isWorking: false
        }
    }),
    // #endregion
    // #region Boostrap
    created() {
        //Mode
        this.status.mode = this.$route.params?.mode;
        //Load
        this.loadData();
    },
    beforeMount() {
        this.$host.eventBus.on('refresh', this.loadData);
    },
    beforeUnmount() {
        this.$host.eventBus.off('refresh', this.loadData);
    },
    // #endregion
    // #region Computed
    computed: {
        isEmpty() {
            if (this.status.mode !== 'cart' && this.status.mode) {
                return false;
            }
            if (utils.isNullOrEmpty(this.cartID)) {
                return true;
            }
            if (!this.cart) {
                return true;
            }
            if (utils.isNullOrEmpty(this.cart?.cartID)) {
                return true;
            }
            if (!this.cart.lines || this.cart.lines.length == 0) {
                return true;
            }
            return false;
        },
        cartID() {
            return this.$route.params.cartID;
        },
    },
    // #endregion
    // #region Watch
    watch: {
        '$route.params.mode': function (value) {
            let tMode = value;
            if (tMode && this.status.mode !== tMode) {
                this.status.mode = tMode;
                this.loadData();
            }
            else {
                this.status.mode = 'cart';
                this.loadData();
            }
        },
        '$route.params.cartID': function (value) {
            //Vars
            this.status.mode = 'cart';
            this.status.hasConditionError = false;
            //Load
            this.loadData();
        },
        '$data.data.shipping.mode': function (value) {
            if (this.status.isLoading || !this.status.isLoaded) {
                return;
            }
            this.saveData('update');
        },
        '$data.data.shipping.avis': function (value) {
            if (this.status.isLoading || !this.status.isLoaded) {
                return;
            }
            this.saveData('update');
        },
        '$data.data.shipping.option_avis': function (value) {
            if (this.status.isLoading || !this.status.isLoaded) {
                return;
            }
            this.saveData('update');
        },
        '$data.data.shipping.option_express': function (value) {
            if (this.status.isLoading || !this.status.isLoaded) {
                return;
            }
            this.saveData('update');
        },
        '$data.data.shipping.option_laufzeit': function (value) {
            if (this.status.isLoading || !this.status.isLoaded) {
                return;
            }
            this.saveData('update');
        },
        '$data.data.addresses.delivery.mode': function (value) {
            if (this.status.isLoading || !this.status.isLoaded) {
                return;
            }
            if (value === 'address') {
                return;
            }
            this.saveData('update');
        },
        '$data.data.addresses.delivery.addressID': function (value) {
            if (this.status.isLoading || !this.status.isLoaded) {
                return;
            }
            this.saveData('update--delivery_addressid');
        },
        '$data.data.addresses.delivery.zipCode': function (value) {
            if (this.status.isLoading || !this.status.isLoaded) {
                return;
            }
            this.saveData('update');
        },
        '$data.data.conditionsconfirmed': function (value) {
            this.status.hasConditionError = false;
        },
    },
    // #endregion
    // #region Core
    methods: {
        // #region CRUD (Cart)
        async loadData() {
            // #region Check
            if (utils.isNullOrEmpty(this.cartID)) {
                return;
            }
            // #endregion
            // #region Reset
            if (this.data?.conditionsconfirmed) {
                this.data.conditionsconfirmed = false;
            }
            // #endregion
            // #region Run
            //Loading
            this.status.isLoading = true;
            host.api.get(`commerce/checkout/${this.cartID}?mode=${this.status.mode}`)
                .then(e => {
                if (e.data?.$dataMode) {
                    this.status.mode = e.data?.$dataMode;
                }
                if (e.data?.cart) {
                    this.cart = e.data.cart;
                }
                if (e.data?.data) {
                    this.data = e.data.data;
                }
                if (e.data?.schema) {
                    this.schema = e.data.schema;
                }
                if (e.data?.messages) {
                    this.status.messages = e.data.messages;
                }
                if (e.data?.breadcrumbs) {
                    this.$store.commit('navigation/setBreadcrumb', e.data.breadcrumbs);
                }
                if (e.data?.$dataMode === 'thankyou') {
                    this.$store.commit('carts/load');
                }
                if (this.schema?.options?.text_Cart) {
                    this.$host.pageMeta.title = this.schema?.options?.text_Cart + " " + this.cart?.cartNumber;
                }
                nextTick(() => {
                    this.status.isLoading = false;
                    this.status.isLoaded = true;
                });
            })
                .catch(e => {
                host.notification.showError(e);
                this.status.isLoading = false;
            });
            // #endregion
        },
        async setData(args) {
            // #region Internal
            if (args?.cart) {
                this.cart = args?.cart;
            }
            if (args?.schema) {
                this.schema = args?.schema;
            }
            // #endregion
            // #region Store
            if (args.cart) {
                this.$store.commit('carts/setCart', args.cart);
            }
            // #endregion
        },
        async loadAfterLogin() {
            try {
                // #region Run
                await host.api.post(`commerce/carts/${this.cartID}/activate`);
                // #endregion
                // #region Store
                this.$store.commit('carts/load');
                // #endregion                        
                // #region Load
                this.loadData();
                // #endregion
            }
            catch (e) {
                host.notification.showError(e);
            }
        },
        async saveData(operationName, onSaved = undefined) {
            // #region Meter
            this.status.isLoading = true;
            // #endregion
            // #region Save
            //Url
            let tUrl = this.status.mode === 'summary' ? `commerce/checkout/${this.cart.cartID}/finish?operation=${operationName}` : `commerce/checkout/${this.cart.cartID}?mode=${this.status.mode}&operation=${operationName}`;
            try {
                // #region Path
                let e = await host.api.patch(tUrl, this.data);
                // #endregion
                // #region Payment
                if (e.data?.$nextMode === 'payment-confirm') {
                    //Run
                    this.runPayment(e.data.payment);
                    //Finish
                    this.status.isLoading = false;
                    this.status.isWorking = false;
                    return;
                }
                // #endregion
                // #region Internal
                if (e.data?.cart) {
                    this.cart = e.data.cart;
                }
                if (e.data?.data) {
                    this.data = e.data.data;
                }
                if (e.data?.schema) {
                    this.schema = e.data.schema;
                }
                if (e.data?.messages) {
                    this.status.messages = e.data.messages;
                }
                if (e.data?.user) {
                    this.user = e.data.user;
                }
                // #endregion
                // #region Store
                if (e.data?.breadcrumbs) {
                    this.$store.commit('navigation/setBreadcrumb', e.data.breadcrumbs);
                }
                if (e.data?.$nextMode === 'thankyou') {
                    this.$store.commit('carts/load');
                }
                else if (e.data?.cart) {
                    this.$store.commit('carts/setCart', e.data.cart);
                }
                // #endregion
                // #region Next
                if (onSaved) {
                    onSaved(e.data?.$nextMode);
                }
                // #endregion
                // #region Loading
                this.status.isLoading = false;
                // #endregion
            }
            // #endregion
            // #region Error
            catch (error) {
                // #region Data
                if (error.response?.data?.messages) {
                    this.status.messages = error.response?.data?.messages;
                }
                else {
                    host.notification.showToast(utils.getAxiosErrorMessage(error), "error");
                }
                // #endregion
                // #region Loading
                this.status.isLoading = false;
                this.status.isWorking = false;
                // #endregion
            }
            // #endregion
        },
        async runPayment(data) {
            // #region Simple (URL)
            if (data?.nextAction === 'redirect_to_url') {
                window.location.href = data.nextActionUrl;
            }
            // #endregion
            // #region Run
            else {
                // #region Gateway
                //Gateway
                let tGateway = this.$host.provider.get('PAYMENT', data.gateway.clientType);
                //Init
                await tGateway.initialize(data.gateway);
                //Handle
                let tResult = await tGateway.handle(data.nextAction, data);
                // #endregion
                // #region Result
                if (!tResult.isSucceeded) {
                    this.status.messages.push({
                        style: 'danger',
                        description: tResult.errorMessage,
                    });
                }
                else if (tResult.nextAction === 'confirm') {
                    this.saveData('payment-confirm', async (nextMode) => {
                        // #region Meter
                        this.status.isWorking = false;
                        // #endregion
                        // #region Rounting
                        this.$router.push({ params: { mode: nextMode ?? 'cart' } });
                        // #endregion
                    });
                }
                // #endregion
            }
            // #endregion
        },
        async runMoveNext(mode) {
            // #region Validate
            let tForm = this.$refs?.frmMain?.$form;
            if (tForm && !tForm.validate()) {
                return;
            }
            if (this.status.mode === 'summary' && this.schema?.options?.agb_Caption && !this.data.conditionsconfirmed) {
                this.status.hasConditionError = true;
                return;
            }
            // #endregion
            // #region Meter
            this.status.isWorking = true;
            // #endregion
            // #region Events
            let tArgs = {
                cancel: false,
                mode: this.status.mode,
                cart: this.cart,
                data: this.data
            };
            //Run
            await host.eventBus.emit('checkout-before-commit', tArgs);
            //Check
            if (tArgs.cancel) {
                this.status.isWorking = false;
                return;
            }
            // #endregion
            // #region Save
            this.saveData(mode, async (nextMode) => {
                // #region Speical
                if (nextMode === 'activate') {
                    await host.login.loginByUsername(this.data.profile.eMail, this.data.profile.password);
                }
                // #endregion
                // #region Meter
                this.status.isWorking = false;
                // #endregion
                // #region Rounting
                this.$router.push({ params: { mode: nextMode ?? 'cart' } });
                // #endregion
            });
            // #endregion
        },
        async runPunchOut() {
            try {
                // #region Meter
                this.status.isLoading = true;
                this.status.isWorking = true;
                // #endregion
                // #region Callback
                //Load
                let e = await host.api.patch(`commerce/checkout/${this.cart.cartID}/oci-punchout`);
                //Result
                if (!e.data) {
                    throw {
                        message: 'Kein OCI-Warenkorb erhalten'
                    };
                }
                this.oci = e.data;
                // #endregion
                // #region Send
                this.$nextTick(() => {
                    this.$refs.ociform.submit();
                });
                // #endregion
                //Loading
                this.status.isLoading = false;
                this.status.isWorking = false;
            }
            catch (e) {
                //Loading
                this.status.isLoading = false;
                this.status.isWorking = false;
                //Show
                host.notification.showError(e);
            }
        },
        async reloadData() {
            // #region Store
            this.$store.commit('carts/load');
            // #endregion                        
            // #region Load
            this.loadData();
            // #endregion
        },
        // #endregion           
        // #region Command
        async onCommand(args) {
            if (args.name === 'load') {
                await this.loadData();
            }
            else if (args.name === 'reload') {
                await this.reloadData();
            }
            else if (args.name === 'set') {
                await this.setData(args);
            }
            else if (args.name === '$reject') {
                this.$router.push({ params: { mode: 'reject' } });
            }
            else if (args.name === 'oci-punchout') {
                await this.runPunchOut();
            }
            else {
                await this.runMoveNext(args.name);
            }
        },
        // #endregion
    },
    // #endregion
});
// #endregion
